import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from './components/layout/Layout.jsx';
import ProtectedRoute from './components/common/ProtectedRoute.jsx';
import Home from './pages/Home.jsx';
import About from './pages/About.jsx';
import Help from './pages/Help.jsx';
import Explore from './pages/Explore.jsx';
import Survey from './pages/Survey.jsx';
import ResearchTools from './pages/ResearchTools.jsx';
import ResearchToolsNew from './pages/ResearchToolsNew.jsx';
import ResearchToolsEdit from './pages/ResearchToolsEdit.jsx';
import BroaderEngagements from './pages/BroaderEngagements.jsx';
import BroaderEngagementsNew from './pages/BroaderEngagementsNew.jsx';
import BroaderEngagementsEdit from './pages/BroaderEngagementsEdit.jsx';
import Bibliography from './pages/Bibliography.jsx';
import BibliographyNew from './pages/BibliographyNew.jsx';
import BibliographyEdit from './pages/BibliographyEdit.jsx';
import Scholars from './pages/Scholars.jsx';
import ScholarsNew from './pages/ScholarsNew.jsx';
import ScholarsEdit from './pages/ScholarsEdit.jsx';
import Organizations from './pages/Organizations.jsx';
import OrganizationsNew from './pages/OrganizationsNew.jsx';
import OrganizationsEdit from './pages/OrganizationsEdit.jsx';
import Teaching from './pages/Teaching.jsx';
import TeachingNew from './pages/TeachingNew.jsx';
import TeachingEdit from './pages/TeachingEdit.jsx';
import WhatsNew from './pages/WhatsNew.jsx';
import WhatsNewNew from './pages/WhatsNewNew.jsx';
import WhatsNewEdit from './pages/WhatsNewEdit.jsx';
import Newsletter from './pages/Newsletter.jsx';
import NewsletterIssue from './pages/NewsletterIssue.jsx';
import NewsletterNew from './pages/NewsletterNew.jsx';
import NewsletterEdit from './pages/NewsletterEdit.jsx';
import Auth from './pages/Auth.jsx';
import AuthCallback from './pages/AuthCallback.jsx';
import AuthConfirm from './pages/AuthConfirm.jsx';
import Profile from './pages/Profile.jsx';
import Admin from './pages/Admin.jsx';
import NotFound from './pages/NotFound.jsx';

function LoadingFallback() {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-screen items-center justify-center text-cream/70"
    >
      Loading…
    </div>
  );
}

export default function App() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="help" element={<Help />} />
          <Route path="explore" element={<Explore />} />
          <Route path="survey" element={<Survey />} />
          <Route path="research-tools" element={<ResearchTools />} />
          <Route element={<ProtectedRoute />}>
            <Route path="research-tools/new" element={<ResearchToolsNew />} />
            <Route path="research-tools/:id/edit" element={<ResearchToolsEdit />} />
          </Route>
          <Route path="broader-engagements" element={<BroaderEngagements />} />
          <Route element={<ProtectedRoute />}>
            <Route path="broader-engagements/new" element={<BroaderEngagementsNew />} />
            <Route path="broader-engagements/:id/edit" element={<BroaderEngagementsEdit />} />
          </Route>
          <Route path="bibliography" element={<Bibliography />} />
          <Route element={<ProtectedRoute />}>
            <Route path="bibliography/new" element={<BibliographyNew />} />
            <Route path="bibliography/:id/edit" element={<BibliographyEdit />} />
          </Route>
          <Route path="scholars" element={<Scholars />} />
          <Route element={<ProtectedRoute />}>
            <Route path="scholars/new" element={<ScholarsNew />} />
            <Route path="scholars/:id/edit" element={<ScholarsEdit />} />
          </Route>
          <Route path="organizations" element={<Organizations />} />
          <Route element={<ProtectedRoute />}>
            <Route path="organizations/new" element={<OrganizationsNew />} />
            <Route path="organizations/:id/edit" element={<OrganizationsEdit />} />
          </Route>
          <Route path="teaching" element={<Teaching />} />
          <Route element={<ProtectedRoute />}>
            <Route path="teaching/new" element={<TeachingNew />} />
            <Route path="teaching/:id/edit" element={<TeachingEdit />} />
          </Route>
          <Route path="whats-new" element={<WhatsNew />} />
          <Route element={<ProtectedRoute />}>
            <Route path="whats-new/new" element={<WhatsNewNew />} />
            <Route path="whats-new/:id/edit" element={<WhatsNewEdit />} />
          </Route>
          <Route path="newsletter" element={<Newsletter />} />
          <Route element={<ProtectedRoute requireAdmin />}>
            <Route path="newsletter/new" element={<NewsletterNew />} />
            <Route path="newsletter/:id/edit" element={<NewsletterEdit />} />
          </Route>
          <Route path="newsletter/:year/:month" element={<NewsletterIssue />} />
          <Route path="auth" element={<Auth />} />
          <Route path="auth/callback" element={<AuthCallback />} />
          <Route path="auth/confirm" element={<AuthConfirm />} />
          <Route element={<ProtectedRoute />}>
            <Route path="profile" element={<Profile />} />
          </Route>
          <Route element={<ProtectedRoute requireAdmin />}>
            <Route path="admin" element={<Admin />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
